import { AgentTestTranscriptComponent } from './types';
import {
  ErrorPreviewLogProps,
  PreviewLogType,
} from 'src/slices/workflow-preview/types';

const ERROR_RECORDED_EVENT_TYPE = 'error_recorded';

/**
 * The error an agent test recorded, if this agent testing component is one.
 *
 * The server stores it as the same ErrorPreviewLog the preview console shows,
 * so it renders identically: message, severity, user impact, payload and the
 * Error Logs "How to fix" guidance.
 */
export const getRecordedErrorPreviewLog = (
  transcriptComponent: AgentTestTranscriptComponent,
): ErrorPreviewLogProps | null => {
  const { event_type: eventType, fields } = transcriptComponent;
  if (
    eventType !== ERROR_RECORDED_EVENT_TYPE ||
    fields?.log_type !== PreviewLogType.ERROR ||
    typeof fields.error_message !== 'string'
  ) {
    return null;
  }
  return fields as unknown as ErrorPreviewLogProps;
};
